export default {
    title: "Encomenda em nome de",
    model: {
        email: {
            label: "E-mail",
            placeholder: "Por favor, preencha o nome de usuário ou o e-mail",
            notFound: "Usuários não encontrados",
            errors: {
                myself: "O endereço de e-mail deve ser diferente do seu"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Enviar",
            processing: "Submissão"
        }
    },
    error: {
        userNotExists: "{email} não existe",
        country: {
            default: "O equipamento não está disponível no país do usuário no momento",
            ALPHA3: ""
        }
    }
}